import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV } from "@/data/site";
import { Wordmark } from "@/components/brand";
import { GoldButton } from "@/components/cta";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled || open ? "bg-navy-dark/95 backdrop-blur-md shadow-softlg" : "bg-navy/70 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3 md:px-10">
        <Link to="/" data-testid="header-logo-link" aria-label="Sankofa Launch Studio home">
          <Wordmark dark showTagline={false} size="sm" />
        </Link>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary">
          {NAV.slice(0, 8).map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `relative font-sans text-sm text-white/85 transition-colors hover:text-gold ${
                  isActive ? "text-gold" : ""
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <GoldButton testid="header-book-btn" />
        </div>

        <button
          className="text-white lg:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-navy-dark px-5 pb-6 pt-2 lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col" aria-label="Mobile">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `border-b border-white/10 py-3 font-sans text-base ${
                    isActive ? "text-gold" : "text-white/85"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-5">
            <GoldButton testid="mobile-book-btn" className="w-full" />
          </div>
        </div>
      )}
    </header>
  );
}
